// Module
var code = "<select class=\"form-control input-sm\" ng-model=\"vm.model\" ng-options=\"item.key as item.value|translate for item in vm.levels\" name=\"{{vm.name}}\" ng-class=\"{'disable': vm.isDisabled}\" id=\"{{vm.name}}\" tabindex=\"-1\"> </select>";
// Exports
module.exports = code;